// extracted by mini-css-extract-plugin
export default {"loader":"WrapperInner__loader--3Yr"};